import { format, getMinutes, isValid, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  width: 100%;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${theme.spaces.regular}px;
`;

const StyledCol = styled.div`
  &:last-child {
    flex-grow: 1;
  }
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: ${theme.colors.green.primary};

  svg {
    fill: ${theme.colors.white};
  }
`;

const MeetingListItem = ({ name, start, end }) => {
  const parsedStart = parseISO(start);
  const parsedEnd = parseISO(end);
  const formattedTime = isValid(parsedStart) ? format(parsedStart, 'MMMM dd, yyyy hh:mm') : start;
  const duration = isValid(parsedEnd) && isValid(parsedStart) ? getMinutes(parsedEnd) - getMinutes(parsedStart) : 15;

  return (
    <StyledContainer>
      <StyledBody>
        <StyledRow>
          <StyledCol>
            <StyledIconContainer>
              <Icon alias={ICON_ALIASES.calling} color={theme.colors.white} />
            </StyledIconContainer>
          </StyledCol>
          <StyledCol>
            <Text size={theme.fontSizes.small} weight={700}>
              {name}
            </Text>
            <Text size={theme.fontSizes.smallX} color={theme.colors.gray.secondary}>
              Call: {formattedTime} / {duration}m
            </Text>
          </StyledCol>
        </StyledRow>
      </StyledBody>
    </StyledContainer>
  );
};

MeetingListItem.propTypes = {
  name: PropTypes.string,
  start: PropTypes.string,
  end: PropTypes.string,
};

export default MeetingListItem;
